import React from 'react';
import { QrCode, Calendar, Clock } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { formatDateTime } from '../utils/format';

// Renders the customer's check-in pass. Uses a real, scannable QR — the
// payload encodes the qrToken (server-issued, single-purpose). Fallback to
// the AIH-XXXX bookingId for typed entry at the counter when scanning fails.
function BookingQrCard({ order }) {
  if (!order?.bookingId) return null;
  const value = order.qrToken || order.bookingId;
  return (
    <div className="card" style={{ marginTop: 'var(--s-4)' }}>
      <div className="card-title">
        <h3><QrCode size={16} style={{ verticalAlign: '-3px', marginRight: 8 }} /> Your booking pass</h3>
        <span className="muted text-sm">Show this at the clinic counter for check-in.</span>
      </div>

      <div className="row" style={{ gap: 'var(--s-4)', alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{
          padding: 12, background: '#fff', borderRadius: 12, border: '1px solid var(--ink-200)',
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        }}>
          <QRCodeSVG value={value} size={180} level="M" includeMargin={false} />
        </div>

        <div style={{ flex: 1, minWidth: 240 }}>
          <div className="muted text-xs" style={{ textTransform: 'uppercase', letterSpacing: '0.18em' }}>
            Booking ID
          </div>
          <div style={{
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            fontSize: 36, fontWeight: 700, letterSpacing: 4, marginTop: 4, color: 'var(--brand-700)',
          }}>
            {order.bookingId}
          </div>
          <div className="muted text-sm" style={{ marginTop: 6 }}>
            Read this code out loud to the clinic if scanning fails.
          </div>

          {(order.scheduledAt || order.scheduledSlot) && (
            <div className="row" style={{ gap: 16, marginTop: 'var(--s-3)', flexWrap: 'wrap' }}>
              {order.scheduledAt && (
                <div className="row" style={{ gap: 6 }}>
                  <Calendar size={14} />
                  <span className="bold">{formatDateTime(order.scheduledAt)}</span>
                </div>
              )}
              {order.scheduledSlot && (
                <div className="row" style={{ gap: 6 }}>
                  <Clock size={14} />
                  <span>{order.scheduledSlot}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BookingQrCard;
